const item = [
    {
        id:0,
        quantity: 3,
        titleO: 'Về GrabFood',
        titleT: 'Về Grab',
        titleTh: 'Blog'
    },
    {
        id:1,
        quantity:2,
        titleO: 'Mở quán trên GrabFood',
        titleT: 'Trở thành tài xế Grab'
    },
    {
        id:2,
        quantity:2,
        titleO: 'Trung tâm hỗ trợ',
        titleT: 'Câu hỏi thường gặp'
    },
    {
        id:3,
        quantity:3,
        srcO: 'blob:https://chat.zalo.me/a2bcca79-fc83-4340-a192-859598d920b1',
        srcT: 'blob:https://chat.zalo.me/e7a381b2-4db7-47fa-892b-a547653366ff',
        srcTh: 'blob:https://chat.zalo.me/0d518704-a355-477a-a012-637810ed63a1',
        altO: 'facebook',
        altT: 'instargram',
        altTh: 'twitter',
    },
]
export default item;